<div class="col-12">
    <p-messages></p-messages>
    <p-toast key="tst"></p-toast>
    <div class="grid">
        <div class="col-12">
            <h3 style="text-align: center;">Rehab Loan</h3>
        </div>
        <div class="col-12">
            <h6>Contact Details:</h6>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="firstName" pInputText> 
                <label for="float-input">First Name <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="lastName" pInputText> 
                <label for="float-input">Last Name <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="phone" pInputText> 
                <label for="float-input">Phone Number <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="email" pInputText> 
                <label for="float-input">Email Address <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="interestedProperty" pInputText> 
                <label for="float-input">Interested Property Address <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="interestedCity" pInputText> 
                <label for="float-input">Interested Property City <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="interestedState" pInputText> 
                <label for="float-input">Interested Property State <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="interestedZip" pInputText> 
                <label for="float-input">Interested Property Zip <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="ficoScore" pInputText> 
                <label for="float-input">Your FICO Score (min 640 allowed) <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="referralSource" pInputText> 
                <label for="float-input">How Did You Find CK Capital? <span style="color:red">*</span></label>
            </span>
        </div>



        <div class="col-12">
            <h6>Loan Details:</h6>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="purchasePrice" pInputText> 
                <label for="float-input">Purchase Price <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="rehabCost" pInputText> 
                <label for="float-input">Rehab Cost <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="arv" pInputText> 
                <label for="float-input">After Repair Value <span style="color:red">*</span></label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <p-dropdown [options]="propertyTypes" [style]="{'width': '100%'}" [(ngModel)]="propertyType" [showClear]="true" optionLabel="name" placeholder="Type of Property"></p-dropdown>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="rentalsInLast36Months" pInputText> 
                <label for="float-input">How Many Rentals Purchased in Last 36 Months?</label>
            </span>
        </div>
        <div class="col-12 sm:col-12 md:col-6">
            <span class="p-float-label pt-2">
                <input autocomplete="off" id="float-input" type="text" [style]="{'width': '100%'}" [(ngModel)]="propertiesOwnedFlipped36Months" pInputText> 
                <label for="float-input">How Many Properties Owned/Flipped in Last 36 Months?</label>
            </span>
        </div>
    </div>

    <p-messages></p-messages>
    <button pButton [disabled]="runningNumbers" label="RUN MY NUMBERS" icon="pi pi-check-square" class="p-button-lg pt-3" (click)="runRehabNumbers()"><i *ngIf="runningNumbers" class="pi pi-spin pi-spinner"></i></button>
</div>
